import React, { useEffect } from "react";
import { Card } from "react-bootstrap";
import FormCreditCard from "./FormCreditCard";
import { EPaymentMethod, useLandingPageContext } from "pages/Context/LandinPageContext";
import FormTicket from "./FormTicket";
import FormPix from "./FormPix";
import { generateInstallments } from "../functions/generateInstallments";
import IconPix from "assets/svgs/IconPix";
import IconBarCode from "components/Icons/IconBarCode";
import IconCreditCard from "components/Icons/IconCreditCard";
import { IPeriodicTime } from "core/enums/plans.enum";

const PLAN_METHOD: Record<EPaymentMethod, string> = {
  [EPaymentMethod.CREDIT_CARD]: "credit_card",
  [EPaymentMethod.PIX]: "pix",
  [EPaymentMethod.BOLETO]: "boleto",
};

const PaymentType = () => {
  const {selectedPlanContext, paymentMethodContext, setPaymentMethodContext, setInstallmentsContext, pixCopyAndPasteContext, quantityOnDemandContext } =  useLandingPageContext();

  const allowed = (method: EPaymentMethod) => {
    const types = selectedPlanContext?.paymentTypes;
    if (!types?.length) return true;
    return types.includes(PLAN_METHOD[method] as never);
  };

  useEffect(() => {
    if (selectedPlanContext && !allowed(paymentMethodContext)) {
      const fallback = [EPaymentMethod.CREDIT_CARD, EPaymentMethod.PIX, EPaymentMethod.BOLETO].find(allowed);
      if (fallback) setPaymentMethodContext(fallback);
    }
  }, [selectedPlanContext, paymentMethodContext, setPaymentMethodContext]);
  
  useEffect(() => {
    if(selectedPlanContext) {
      let installmenst;
      if(selectedPlanContext.period.type === IPeriodicTime.ON_DEMAND) {
        installmenst = generateInstallments(selectedPlanContext?.allAmount, selectedPlanContext?.period.installmentCount, quantityOnDemandContext);
      } else {
        installmenst = generateInstallments(selectedPlanContext?.allAmount, selectedPlanContext?.period.installmentCount);
      }
      setInstallmentsContext(installmenst);
    }
  }, [selectedPlanContext, quantityOnDemandContext, setInstallmentsContext]);

  const FormPayment = {
    [EPaymentMethod.CREDIT_CARD]: <FormCreditCard />,
    [EPaymentMethod.PIX]: <FormPix />,
    [EPaymentMethod.BOLETO]: <FormTicket />
  }[paymentMethodContext];

  return (
    <div className="d-flex flex-column gap-2 bg-gray-50 rounded">
      <Card.Header className="d-md-flex justify-content-between align-items-center border-bottom">
        <Card.Title className="flex-grow-1 d-flex justify-content-start px-4 pt-3 pb-sm-0 pb-md-3">Escolha a forma de pagamento</Card.Title>
        { !pixCopyAndPasteContext &&
          <div className="flex-grow-1 d-flex justify-content-end gap-4 px-4 my-1" style={{ fontSize: ".75rem", width: "fit-content"}}>
            {allowed(EPaymentMethod.CREDIT_CARD) && (
            <div className="d-flex gap-2 align-items-center">
              <input type="radio" name="radio-1" className="radio radio-xs" checked={paymentMethodContext === EPaymentMethod.CREDIT_CARD} onClick={() => setPaymentMethodContext(EPaymentMethod.CREDIT_CARD)} />
              <div className="d-flex gap-1 align-items-center">
                <IconCreditCard />
                <span className="fw-bold">Cartão</span>
              </div>
            </div>
            )}

            {allowed(EPaymentMethod.PIX) && (
            <div className="d-flex gap-2 align-items-center">
              <input type="radio" name="radio-1" className="radio radio-xs" checked={paymentMethodContext === EPaymentMethod.PIX} onClick={() => setPaymentMethodContext(EPaymentMethod.PIX)} />
              <div className="d-flex gap-1 align-items-center">
                <IconPix width={15} className=""/>
                <span className="fw-bold">Pix</span>
              </div>
            </div>
            )}

            {allowed(EPaymentMethod.BOLETO) && (
            <div className="d-flex gap-2 align-items-center">
              <input type="radio" name="radio-1" className="radio radio-xs" checked={paymentMethodContext === EPaymentMethod.BOLETO} onClick={() => setPaymentMethodContext(EPaymentMethod.BOLETO)} />
              <div className="d-flex gap-1 align-items-center">
                <IconBarCode/>
                <span className="fw-bold">Boleto</span>
              </div>
            </div>
            )}
          </div>
        }
      </Card.Header>

      <Card.Body className="flex-grow-1 w-100 d-flex gap-5 align-items-center  px-3 px-lg-5 px-md-3 px-sm-3">
        {FormPayment}
      </Card.Body>
    </div>
 
  );
};

export default PaymentType;
